import http from 'plugins/axios'

const BASE_URL = '/ta/admin/tenant/welfare/bonus/statistic'

export default {
  recycle(data) {
    return http.post({ url: `${BASE_URL}/recycle?summaryId=${encodeURIComponent(data.summaryId)}&statisticsDate=${encodeURIComponent(data.statisticsDate)}` })
  },
  list(data) {
    return http.get({
      url: `${BASE_URL}/list`,
      data,
    })
  },
  summary(data) {
    return http.get({
      url: `${BASE_URL}/summary`,
      data,
    })
  },
  detail(data) {
    return http.get({
      url: `${BASE_URL}/detail`,
      data,
    })
  },
  pendingDetail(data) {
    return http.get({
      url: `${BASE_URL}/pendingDetail`,
      data,
    })
  },
  exportExcel(data) {
    return http.get({
      url: `${BASE_URL}/export`,
      data,
      responseType: 'blob',
    })
  },
}
